import React, { useContext, useState, useEffect } from "react";
import { Field, Form, Formik } from "formik";
import { useHistory, Link } from "react-router-dom";
import * as Yup from "yup";

import { GlobalLoaderContext } from "store/context";
import { GlobalAuthContext } from "store/context";
import { FitinsurAPI, MessageCenter } from "utils";
import Crypt from "utils/src/crypt";
import Colors from "constants/Colors";
import Acess from 'constants/Acess';

import { Header, Footer } from "components";
import Loader from "components/Loader";
import { Button } from "components";
import { InputField, Section } from "components/Form";
import { Col, Row } from "components/Grid";
import { BaseWrapper } from "../../styles";
import { LoginContainer, ButtonContainer, TextStyled } from "./styles";

export default function LoginPage() {
  console.log("LoginPage - BEGIN");

  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const crypt = new Crypt();

  const [showPassword, setShowPassword] = useState(false);
  const [loginState, setLoginState] = useState(authContext.status);
  const [subtitleMessage, setSubtitleMessage] = useState(
    "Por favor insira seu email e senha para continuar"
  );
  const history = useHistory();
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();

  const goToHomePage = () => {
    history.push("quotes");
  };

  const goToChangePassPage = () => {
    authContext.changedPassword = false;
    history.push("change-password");
  };

  const handleSubmit = async (values) => {
    loading.start();
    console.log("onSubmit - BEGIN");

    fitinsur.requestLogin(values.username, values.password)
      .then((response) => {
        console.log(response);
        return response.json();
      })
      .then((data) => {
        console.log("requestLogin - Success:", data);
        authContext.login_response = data;
        // capturando o token do usuario no conteudo da resposta
        const { token } = data.ret_value;

        if (data.ret_code == "200") {

          //-------------------------------------------------------------
          // 20210328 - fix primeiro login
          console.log("requestLogin - loginCount: ", data.ret_value.loginCount);
          console.log("requestLogin - userChangePassword: ", data.ret_value.userChangePassword);
          if (data?.ret_value
            && (Number(data.ret_value.loginCount) <= 0
              || Number(data.ret_value.userChangePassword) > 0)) {
            loading.stop();
            goToChangePassPage();
            return;
          }
          //-------------------------------------------------------------

          // verificando acesso ao sistema FITINSUR do usuario no token recebido
          console.log("requestAccess - Application Domain: ", Acess.APPLICATION_FITINSUR);
          fitinsur.setAuthToken(token);
          fitinsur.requestAccess("READ", Acess.APPLICATION_FITINSUR, null, null, token)
            .then((resp) => resp.json())
            .then((responseAcess) => {
              // se retornar 200 acesso permitido
              if (responseAcess.ret_code == "200") {
                authContext.status = true;
                authContext.username = values.username;
                if (data.ret_token) authContext.token = data.ret_token; // LEGACY LOGIN
                if (data.ret_value.token)
                  authContext.token = data.ret_value.token; // LOGIN V2
                authContext.person_product = data.ret_person_product;
                authContext.region = data.ret_value.region;
                authContext.enumProfile = data.ret_value.enumProfile;
                //authContext.firstLogin = data.ret_value.message == "FIRST LOGIN - CHANGE PASSWORD REQUIRED" ?? true;
                authContext.firstLogin = false;
                if (data.ret_value) {
                  authContext.firstLogin =
                    Number(data.ret_value.loginCount) <= 0;
                };
                localStorage.setItem('session', crypt.encryptJson(authContext));
                (authContext.firstLogin || data.ret_value.userChangePassword > 0)
                ? goToChangePassPage()
                : goToHomePage();
              } else {
                mc.error("Erro ao acessar o sistema");
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          authContext.status = false;
          authContext.username = values.username;
          authContext.token = "";
          authContext.person_product = [];
          authContext.user_region = "";
          setLoginState(false);
          //Header.subtitle = "Erro ao acessar o sistema";
          mc.error("Erro ao acessar o sistema");
        }
        loading.stop();
      })
      .catch((error) => {
        authContext.status = false;
        authContext.username = values.username;
        authContext.token = "";
        authContext.person_product = [];
        authContext.user_region = "";
        authContext.login_response = "ERROR: " + error.message;

        console.error("requestLogin - Error:", error);
        setLoginState(false);
        loading.stop();
        mc.error("Erro ao acessar o sistema");
        setSubtitleMessage("Erro ao acessar o sistema");
      });

    console.log("onSubmit - END");
  }

  useEffect(() => localStorage.removeItem('session'), []);

  return (
    <BaseWrapper>
      <LoginContainer>
        <Row>
          <Col xs={12} md={12}>
            <Header title="Acesso" subtitle={subtitleMessage}></Header>
          </Col>
        </Row>

        <Formik
          initialValues={{
            username: authContext.username || "",
            password: "",
          }}
          validationSchema={Yup.object({
            username: Yup.string() /*.email('Invalid email')*/
              .required("* Campo obrigatório"),
            password: Yup.string().required("* Campo obrigatório"),
          })}
          onSubmit={(values) => handleSubmit(values)}
        >
          {(props) => (
            <Form>
              <Section>
                <Row>
                  <Col xs={12} md={12}>
                    <Field
                      name="username"
                      label="E-mail:"
                      type="text"
                      component={InputField}
                      isRequired
                      hideLabelAsterisk
                      disabled={loginState == true}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} md={12}>
                    <Field
                      name="password"
                      label="Senha:"
                      rightIcon={showPassword ? "closedEye" : "openEye"}
                      rightIconClick={() => setShowPassword(state => !state)}
                      type={showPassword ? "text" : "password"}
                      component={InputField}
                      isRequired
                      hideLabelAsterisk
                      disabled={loginState == true}
                    />
                    <Link
                      to="forgot-password"
                      style={{ textDecoration: "none" }}
                    >
                      <TextStyled>Esqueceu sua senha?</TextStyled>
                    </Link>
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} md={12} style={{ position: "static" }}>
                    <ButtonContainer>
                      {loginState == true &&
                        ((authContext.status = false), setLoginState(false))}
                      {/* linha de cima é do botão logout na pagina login */}

                      {loginState !== true && (
                        <Button
                          primary
                          type="submit"
                          id="btnLogin"
                          style={{}}
                          disabled={loginState == true}
                        >
                          ENTRAR
                        </Button>
                      )}
                    </ButtonContainer>
                  </Col>
                </Row>
              </Section>

            </Form>
          )}
        </Formik>

        {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
      </LoginContainer>
      <Footer />
    </BaseWrapper>
  );
}
